module.exports = require("cloudinary-core");


//////////////////
// WEBPACK FOOTER
// external "cloudinary-core"
// module id = 184
// module chunks = 0